module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1356.4dd560b0.jpg";